package com.flowyride.core.domain.routing

/** Failures a [RouteEngine] may report. */
sealed class RoutingException(message: String, cause: Throwable? = null) : Exception(message, cause) {

    /** The engine found no road between the waypoints. */
    class NoRouteFound(details: String? = null) :
        RoutingException(details ?: "No route found between these points")

    /** More stops than the engine accepts in one request. */
    class TooManyWaypoints(val max: Int) : RoutingException("At most $max waypoints are supported")

    /** The engine is misconfigured or refused the request (quota, API key…). */
    class EngineUnavailable(reason: String) : RoutingException(reason)

    /** Too many requests in a short time: try again later. */
    class RateLimited(details: String? = null) : RoutingException(details ?: "Too many requests, try again in a minute")

    /** The engine could not be reached. */
    class Network(cause: Throwable) : RoutingException("Network error: ${cause.message}", cause)

    /** The engine answered something we could not understand. */
    class InvalidResponse(details: String, cause: Throwable? = null) : RoutingException(details, cause)
}
